<template>
  <div class="doctorpc-exam">
    <docpc-steps :current="stepActive"></docpc-steps>
    <div class="docpc-panel">
      <!-- <div class="docpc-msg msg-page">
        <div class="msg-hd">
          <div class="msg-png" style="height: auto;">
            <img :src="msg.png" alt="">
          </div>
        </div>
        <div class="msg-bd">
          <div class="title">{{msg.title}}</div>
          <div class="desc">{{msg.desc}}</div>
        </div>
        <div class="msg-ft">
          <van-button v-for="(item, index) in msgButtons" :key="index" :color="item.color" size="small" @click="item.onClick">
            {{item.txt}}</van-button>
        </div>
      </div> -->
    </div>

    <van-popup class="contract-popup" v-model="showContract" closeable close-icon-position="top-left" position="center" :close-on-click-overlay="false">
      <div class="contract-box">
        <div class="contract-title">培训及考核说明</div>
        <div class="contract-text" v-html="contractText"></div>
        <div class="contract-btn">
          <van-button :color="themeColor" @click="startExam">进入培训</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import '@vant/touch-emulator' // 解决vant组件在pc端不支持touch事件
import iconsuccess from "@/assets/docpc/icon_success.png"
import iconwarn from "@/assets/docpc/icon_warn.png"
import iconerror from "@/assets/docpc/icon_error.png"
import docpcSteps from "@/doctor_pc/components/steps/steps.vue"
import {
  mapState,
  mapActions
} from "vuex";

export default {
  name: 'docpcExamHome',
  components: {
    docpcSteps
  },
  data() {
    return {
      themeColor: 'linear-gradient(to bottom, #23C7C3, #07A7B4)',
      icon_success: iconsuccess,
      icon_warn: iconwarn,
      icon_error: iconerror,
      stepActive: 1,
      doctor_info: null,
      // msg: {
      //   status: '', // success;warn;info;error
      //   icon: '', // vant-ui Icon name
      //   png: iconsuccess,
      //   title: '您好，您的注册信息已经审核通过，请您参加培训考试，感谢您的理解与支持！',
      //   desc: ''
      // },
      msgButtons: [],
      showContract: true,
      contractText: `<p><span style="font-weight:bold">培训内容共分为三个部分：</span></p>
      <p>一、基金会介绍：公益宗旨、援助项目规模等;</p>
      <p>二、项目介绍：项目背景及援助方案、对象、药品等;</p>
      <p>三、项目医学评估：援助流程、医学材料及医生职责等。</p>
      <br/>
      <p><span style="font-weight:bold">考核要求：</span></p>
      <p><span style="font-weight:bold">•</span>观看完培训视频将有考核，所有答题须全部回答正确。</p>`
    }
  },
  computed: {
    ...mapState(['docpc']),
  },
  created() {
    // if (this.docpc) {
    //   this.stepActive = 1
    //   this.msgButtons = [{
    //     txt: '前往考试培训模块',
    //     color: this.themeColor,
    //     onClick: this.showPop.bind(this)
    //   }]
    // }
  },
  methods: {
    showPop() {
      this.showContract = true
    },
    startExam() {
      this.$router.replace({
        name: "docpcExamPage",
      });
    }
  }
}
</script>

<style lang='less'>
.doctorpc-exam {
  .van-popup--center {
    background: transparent;
  }
  .docpc-panel {
    height: calc(100vh - 100px);
  }
  .contract-box {
    position: relative;
    height: 300px;
    display: flex;
    flex-direction: column;
    padding-bottom: 40px;
    margin-bottom: 20px;
    background: #fff;

    .contract-title {
      background: #fff;
      box-sizing: content-box;
      width: auto;
      line-height: 24px;
      height: 24px;
      font-size: 1.6rem;
      text-align: center;
      padding: 20px 50px 10px;
      background: #fff;
    }

    .contract-text {
      flex: 1;
      height: 50%;
      font-size: 1.4rem;
      text-align: justify;
      text-align-last: left;
      line-height: 1.5;
      height: 100%;
      padding: 15px;
      overflow-y: auto;
      transition: transform .3s;
      -webkit-overflow-scrolling: touch;
    }

    .contract-btn {
      background: #fff;
      position: absolute;
      left: 50%;
      bottom: -20px;
      margin-left: -60px;
      .van-button {
        width: 120px;
      }
    }
  }
}
</style>